import { render, staticRenderFns } from "./grabList.vue?vue&type=template&id=38079e64&scoped=true&"
import script from "./grabList.vue?vue&type=script&lang=js&"
export * from "./grabList.vue?vue&type=script&lang=js&"
import style0 from "./grabList.vue?vue&type=style&index=0&id=38079e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38079e64",
  null
  
)

export default component.exports